module.exports = __webpack_public_path__ + "img/6.0e7f4f73.jpg";